import { MakeCall } from './createMakeCall';

export default (makeCall: MakeCall) => (data: {
  countryCode: string;
  phone: string;
}) =>
  makeCall('POST', '/api/v2/validation/phone', {
    data,
  });
